<html>
  <metainfo>
    <template v-slot:title="">Tomasz Tylikowski Fotografia</template>
  </metainfo>

<body>
  <div>
    <nav class="navbar navbar-dark bg-dark" aria-label="">
      <div class="container justify-content-center">
        <a>
          <img src="./assets/logo3.png" class="rounded" alt="logo" width="194" height="95">
        </a>
      </div>
    </nav>
    <div class="container text-center">
      <a href="https://www.facebook.com/people/Tomasz-Tylikowski-Fotografia/100082995087394/" target="_blank"><img
          src="./assets/facebook.png" class="rounded mx-auto " style="width: 40px; height: 80px; padding-top: 40px;"
          alt="facebook"></a>
      <a href="https://www.instagram.com/tomek_tylikowski_sportovo/" target="_blank"><img src="./assets/instagram.png"
          class="rounded mx-auto " style="width: 45px; height: 80px; padding-left: 5px; padding-top: 40px;"
          alt="instagram"></a>
    </div>
    <div class="row" style="padding-top: 40px;">
      <img id="img101" src="./assets/image00001.jpeg" class="" style=" padding-left: 0px; padding-right: 0px; overflow: hidden;"
        alt="img">
        <img id="img102" src="./assets/image00002.jpeg" class="" style=" padding-left: 0px; padding-right: 0px; overflow: hidden;"
        alt="img">
        <img id="img103" src="./assets/image00003.jpeg" class="" style=" padding-left: 0px; padding-right: 0px; overflow: hidden;"
        alt="img">
        <img id="img104" src="./assets/image00004.jpeg" class="" style=" padding-left: 0px; padding-right: 0px; overflow: hidden;"
        alt="img">
        <img id="img105" src="./assets/image00005.jpeg" class="" style=" padding-left: 0px; padding-right: 0px; overflow: hidden;"
        alt="img">
        <img id="img106" src="./assets/image00006.jpeg" class="" style=" padding-left: 0px; padding-right: 0px; overflow: hidden;"
        alt="img">
        <img id="img107" src="./assets/image00007.jpeg" class="" style=" padding-left: 0px; padding-right: 0px; overflow: hidden;"
        alt="img">
        <img id="img108" src="./assets/image00008.jpeg" class="" style=" padding-left: 0px; padding-right: 0px; overflow: hidden;"
        alt="img">
        <img id="img109" src="./assets/image00009.jpeg" class="" style=" padding-left: 0px; padding-right: 0px; overflow: hidden;"
        alt="img">
        <img id="img110" src="./assets/image00010.jpeg" class="" style=" padding-left: 0px; padding-right: 0px; overflow: hidden;"
        alt="img">
        <img id="img111" src="./assets/image00011.jpeg" class="" style=" padding-left: 0px; padding-right: 0px; overflow: hidden;"
        alt="img">
        <img id="img112" src="./assets/image00012.jpeg" class="" style=" padding-left: 0px; padding-right: 0px; overflow: hidden;"
        alt="img">
      <img id="img1" src="./assets/1.jpg" class=""
        style=" width: 500px; height: auto; padding-left: 0px; padding-right: 0px; overflow: hidden;" alt="img">
      <img id="img2" src="./assets/2.jpg" class=""
        style=" width: 500px; height: auto;padding-left: 0px; padding-right: 0px; overflow: hidden;" alt="img">
      <img id="img3" src="./assets/3.jpg" class=""
        style=" width: 500px; height: auto;padding-left: 0px; padding-right: 0px; overflow: hidden;" alt="img">
      <img id="img4" src="./assets/4.jpg" class=""
        style=" width: 500px; height: auto;padding-left: 0px; padding-right: 0px; overflow: hidden;" alt="img">
      <img id="img5" src="./assets/5.jpg" class="" style=" padding-left: 0px; padding-right: 0px; overflow: hidden;"
        alt="img">
      <img id="img6" src="./assets/6.jpg" class="" style=" padding-left: 0px; padding-right: 0px; overflow: hidden;"
        alt="img">
      <img id="img7" src="./assets/7.jpg" class="" style=" padding-left: 0px; padding-right: 0px; overflow: hidden;"
        alt="img">
      <img id="img8" src="./assets/8.jpg" class="" style=" padding-left: 0px; padding-right: 0px; overflow: hidden;"
        alt="img">
      <img id="img9" src="./assets/9.jpg" class="" style=" padding-left: 0px; padding-right: 0px; overflow: hidden;"
        alt="img">
      <img id="img10" src="./assets/10.jpg" class="" style=" padding-left: 0px; padding-right: 0px; overflow: hidden;"
        alt="img">
      <img id="img11" src="./assets/11.jpg" class="" style=" padding-left: 0px; padding-right: 0px; overflow: hidden;"
        alt="img">
      <img id="img12" src="./assets/12.jpg" class="" style=" padding-left: 0px; padding-right: 0px; overflow: hidden;"
        alt="img">        
    </div>

    <div class="row h-100 p-5 text-bg-dark rounded-3">
      <p>Hej, nazywam się Tomek Tylikowski i jestem fotografem. Moją specjalnością są zdjęcia portretowe oraz
        reportażowe.
        Kilkuletnie doświadczenie, liczne kursy i zdobyte umiejętności potwierdzone certyfikatami sprawiły, że
        utrwalenie
        swojego wizerunku powierzyło mi już bardzo dużo osób. Pełne portfolio dostępne jest na moim profilu na
        Instagramie. Serdecznie zapraszam do współpracy.</p>
    </div>
    <div class="row">
      <div class="col"><a href="mailto: tomasztylikowski@gmail.com" class="link-dark"><img src="./assets/mail.png"
            class="rounded mx-auto " alt="mail">
          <p>tomasztylikowski@gmail.com</p>
        </a></div>
      <div class="col"><a href="tel:+48516198223" class="link-dark"><img src="./assets/phone.png"
            class="rounded mx-auto " alt="phone">
          <p>
            516 198 223
          </p>
        </a>
      </div>
    </div>
    <div class="row h-20 p-5 text-bg-dark rounded-3">
    </div>
  </div>
</body>

</html>